import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Add preloading hints for critical routes
const preloadRoutes = () => {
  // Use setTimeout to avoid blocking main thread during initial render
  setTimeout(() => {
    const preloadLinks = [
      // Add preload links for critical JavaScript chunks
      { rel: 'preload', href: '/static/js/pos.chunk.js', as: 'script' },
      { rel: 'preload', href: '/static/js/appointments.chunk.js', as: 'script' },
      { rel: 'preload', href: '/static/js/customers.chunk.js', as: 'script' },
    ];

    preloadLinks.forEach(attrs => {
      const link = document.createElement('link');
      Object.entries(attrs).forEach(([key, value]) => {
        link.setAttribute(key, value);
      });
      document.head.appendChild(link);
    });
  }, 1000);
};

// Create root and render
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize preloading of critical routes
preloadRoutes();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker update notification
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    if (process.env.NODE_ENV === 'production') {
      navigator.serviceWorker.getRegistration().then(registration => {
        if (registration) {
          // Check for updates every 30 minutes
          setInterval(() => {
            registration.update();
          }, 30 * 60 * 1000);
        }
      });
    }
  });
}
